import React from 'react'
import { Tab } from 'client/shared/blocks/tab/tab'
import { BookshelfTopic } from 'client/bookmate/pages/shelves-page'
import urlFor from 'shared/tools/url-helper'
import './shelves-nav.styl'
import { QueryParams } from 'shared/tools/url-helper'

export const TopicTab = ({
  topic,
  pathname,
  query,
}: {
  topic: BookshelfTopic
  pathname: string
  query?: QueryParams
}): JSX.Element => {
  const { slug } = topic
  const isTabActive = pathname.includes(slug)

  return (
    <Tab
      path={urlFor.bookshelvesTopic(`t-${slug}`, query)}
      kind="column"
      disableLoginWall
      onlyActiveOnIndex
      active={isTabActive}
    >
      {topic.title}
    </Tab>
  )
}
